import { useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../config/firebase';

/**
 * Hook pour récupérer le rôle de l'utilisateur admin (adminUsers collection)
 * @returns {{ role: number | null, loading: boolean }}
 */
export const useAdminRole = () => {
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (!currentUser) {
        setRole(null);
        setLoading(false);
        return;
      }

      try {
        const userDocRef = doc(db, 'adminUsers', currentUser.uid);
        const userDocSnap = await getDoc(userDocRef);
        const userRole = userDocSnap.exists() ? (userDocSnap.data().role ?? 1) : 1;
        setRole(userRole);
      } catch (error) {
        console.error('Erreur lors du chargement du rôle:', error);
        setRole(1); // Par défaut, pas d'accès aux reviews
      } finally {
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, []);

  return { role, loading };
};

